import {MASK_PREFIX_ID, SMART_OBJECT} from "@frontend/constants/templates-field-prefixes";
import {
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_BACKGROND_THEME_IMAGE_MULTIPLE,
  FIELD_TYPE_BACKGROUND_IMAGE_UPLOAD,
  FIELD_TYPE_PRODUCT_IMAGE
} from "@frontend/constants/type-fields-of-template";

// Kept apart from ./index.js so the sidebar buttons can gate on this without importing
// the merge implementation and the canvas module graph behind it.

// Static Image, Upload Image, and Image From Background are excluded: their canvas
// objects never get a `fieldType` set, so they could never actually satisfy this check.
const MERGEABLE_FIELD_TYPES = [
  FIELD_TYPE_PRODUCT_IMAGE,
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_BACKGROND_THEME_IMAGE_MULTIPLE,
  FIELD_TYPE_BACKGROUND_IMAGE_UPLOAD
];

export function isMergeableImageObject(object) {
  if (window.isBannerBuilder || window.isDisplayBuilder) {
    return false;
  }

  if (!object || !MERGEABLE_FIELD_TYPES.includes(object.fieldType)) {
    return false;
  }

  if (object.id?.startsWith(MASK_PREFIX_ID) || object.id?.startsWith(SMART_OBJECT)) {
    return false;
  }

  // isApplyToAll: deleting one of those reaches into every template.
  if (object.isClippingMask || object._isSeeThrough || object.isApplyToAll) {
    return false;
  }

  return !object.groupName && !object.locked && object.selectable !== false && object.visible !== false;
}

export function canMergeObjects(objects) {
  return Array.isArray(objects) && objects.length > 1 && objects.every(isMergeableImageObject);
}
